export default "__VITE_ASSET__BopNvLj3__"